export var AUTH_MESSAGES = {
    success_auth_api: "Seção do usuário registrada com sucesso.",
    success_auth_storage: "Seção do usuário recuperada com sucesso.",
    error: "Falha ao registrar seção do usuário."
};
